import { userConstants } from "../../constant";

const initialState = {
  disputes: [],
  currentDispute: null,
  arbitration: null,
};

export function buyerDisputes(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_BUYER_DISPUTES:
      return { ...state, disputes: action.disputes };

    case userConstants.CREATE_BUYER_DISPUTE:
      return {
        ...state,
        disputes: [action.dispute, ...state.disputes],
      };

    case userConstants.GET_DISPUTE_DETAIL:
      return { ...state, currentDispute: action.dispute };

    case userConstants.UPLOAD_DISPUTE_EVIDENCE:
      if (state.currentDispute && state.currentDispute.id === action.disputeId) {
        return {
          ...state,
          currentDispute: {
            ...state.currentDispute,
            evidence_files: [
              ...(state.currentDispute.evidence_files || []),
              action.evidence,
            ],
          },
        };
      }
      return state;

    case userConstants.APPEAL_DISPUTE:
      return {
        ...state,
        currentDispute: action.dispute,
        disputes: state.disputes.map((d) =>
          d.id === action.dispute.id ? action.dispute : d
        ),
      };

    // Arbitration
    case userConstants.REQUEST_ARBITRATION:
    case userConstants.GET_ARBITRATION_STATUS:
    case userConstants.CONFIRM_ARBITRATION_BOND:
      return { ...state, arbitration: action.arbitration };

    case userConstants.PAY_ARBITRATION_BOND:
      return {
        ...state,
        arbitration: action.arbitration,
      };

    default:
      return state;
  }
}
